export const portfolioItems = [
  {
    title: "TiviMate v5.3.3",
    image: "https://i.postimg.cc/gksBr7yQ/2026-07-30-12-47-50.jpg",
    isNew: true
  },
  {
    title: "MediaBox HD",
    image: "https://i.postimg.cc/BnvZ1xxQ/2026-07-30-11-28-40.jpg",
    isNew: true
  },
  {
    title: "Tivimate V5.1",
    image: "https://i.postimg.cc/YSnBs8yn/Tivimate.jpg"
  },
  {
    title: "XC2000",
    image: "https://i.postimg.cc/Kz1hSLdp/XC.gif"
  },
  {
    title: "IBO PRO",
    image: "https://i.postimg.cc/R0sxDGbn/IBO-PRO.jpg"
  },
  {
    title: "WEYD",
    image: "https://i.postimg.cc/9f8Hn1Nk/Weyd.jpg"
  },
  {
    title: "VUE",
    image: "https://i.postimg.cc/nLRfPTw5/VUE.jpg"
  },
  {
    title: "IB Smarters",
    image: "https://i.postimg.cc/pdXtC3kJ/IB-Smarters.jpg"
  },
  {
    title: "SmartersAds",
    image: "https://i.postimg.cc/d0HcxnSB/Smarters-ADs.jpg"
  },
  {
    title: "HDO",
    image: "https://i.postimg.cc/s2DRmbK9/HDO.jpg"
  },
  {
    title: "Smarters Pro",
    image: "https://i.postimg.cc/7LsrWXQK/SMarters-PRo.png"
  },
  {
    title: "Nio Player",
    image: "https://i.postimg.cc/KYqhHQsT/NIO.jpg"
  },
  {
    title: "MEGA Player",
    image: "https://i.postimg.cc/BvYfVNwP/MEGA.jpg"
  },
  {
    title: "1 Stream",
    image: "https://i.postimg.cc/SKNpdHVc/1-Stream.jpg"
  },
  {
    title: "Stremio (Coming soon)",
    image: "https://i.postimg.cc/d0HcxnSW/Stremio.jpg"
  },
  {
    title: "APK HUB",
    image: "https://i.postimg.cc/rpFLj7gS/apk-hub.jpg"
  },
  {
    title: "9XStream",
    image: "https://i.postimg.cc/nLct2NTK/9xstream.jpg"
  },
  {
    title: "Legazy Player",
    image: "https://i.postimg.cc/TP7v4QHL/legazy.jpg"
  },
  {
    title: "NEXTV",
    image: "https://i.postimg.cc/hGyR5M3d/nextv.jpg"
  },
  {
    title: "Smarters V3 V4 V5",
    image: "https://i.postimg.cc/FKWXBGnC/Smarters.png"
  },
  {
    title: "Purple Neu",
    image: "https://i.postimg.cc/bvCfBLF0/Purple-Neu.jpg"
  },
  {
    title: "Purple Easy Player",
    image: "https://i.postimg.cc/N0JvzbP6/Purple-Easy-Player.jpg"
  },
  {
    title: "Purple Player",
    image: "https://i.postimg.cc/d0HcxnSj/Purple-Player.jpg"
  },
  {
    title: "Promo Videos & Graphics",
    image: "https://i.postimg.cc/QM4ZySn1/Promo.png"
  }
];